import React from 'react';
import mark from '../../assets/audicio-mark.svg';
import markInvers from '../../assets/audicio-mark-invers.svg';

const MARK_SOURCES = { mark, 'mark-invers': markInvers };
const FONT = "'IBM Plex Sans', ui-sans-serif, system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif";

/**
 * Logo — Audicio brand mark. `variant="lockup"` (default) renders the icon
 * plus wordmark as separate elements so icon size (`height`) and wordmark
 * size (`fontSize`) can be tuned independently — the flat lockup SVG ties
 * both together at a fixed ratio, which reads too small at compact heights.
 * `variant="mark"`/`"mark-invers"` renders the icon only (invers for dark
 * backgrounds).
 */
export function Logo({ variant = 'lockup', height = 28, fontSize, style = {}, ...rest }) {
  if (variant !== 'lockup') {
    return (
      <img
        src={MARK_SOURCES[variant] || mark}
        alt="Audicio"
        height={height}
        style={{ display: 'block', width: 'auto', ...style }}
        {...rest}
      />
    );
  }

  const wordmarkSize = fontSize || Math.round(height * 0.85);

  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: Math.round(height * 0.28), ...style }} {...rest}>
      <img src={mark} alt="" height={height} style={{ display: 'block', width: 'auto', flexShrink: 0 }} />
      <span style={{
        fontFamily: FONT, fontWeight: 700, fontSize: wordmarkSize,
        letterSpacing: '-0.02em', color: '#101623', lineHeight: 1,
      }}>
        Audi<span style={{ color: '#1E4FBE' }}>cio</span>
      </span>
    </span>
  );
}
